import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FrequencyFormComponent } from './frequency-form/frequency-form.component';
import { FrequencyViewComponent } from './frequency-view/frequency-view.component';
import { FrequencyListComponent } from './frequency-list/frequency-list.component';
import { MaterialModule } from '../material/material.module';
import { SharedModule } from '../shared/shared.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FrequencyReportComponent } from './frequency-report/frequency-report.component';
import { ComponentsModule } from '../components/components.module';
import { FrequencyCardComponent } from './frequency-card/frequency-card.component';

@NgModule({
  declarations: [FrequencyFormComponent, FrequencyViewComponent, FrequencyListComponent, FrequencyReportComponent, FrequencyCardComponent],
  imports: [CommonModule, MaterialModule, SharedModule, ScrollingModule, ComponentsModule],
})
export class FrequencyModule {}
